import { NavLink } from "react-router-dom";
import { useState } from "react";
import "../css/Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="salon-header">

        {/* TOP STRIP */}
        <div className="salon-top">
          <p>Luxury Hair · Skin · Beauty Studio</p>
          <p>Downtown · By Appointment Only</p>
        </div>

        {/* MAIN HEADER */}
        <div className="salon-header-inner">

          {/* LOGO */}
          <div className="salon-logo">
            ÉLAN
            <span>Salon & Studio</span>
          </div>

          {/* DESKTOP NAV */}
          <nav className="salon-nav">
            <NavLink to="/" end>Home</NavLink>
            <NavLink to="/about">About</NavLink>
            <NavLink to="/services">Services</NavLink>
            <NavLink to="/gallery">Gallery</NavLink>
            <NavLink to="/team">Team</NavLink>
            <NavLink to="/reviews">Reviews</NavLink>
            <NavLink to="/faqs">FAQs</NavLink>
            <NavLink to="/contact">Contact</NavLink>
          </nav>

          {/* RIGHT */}
          <div className="salon-right">
            <a href="#" className="book-btn">Book</a>

            {/* MOBILE TOGGLE */}
            <button
              className="salon-menu-toggle"
              onClick={() => setOpen(true)}
            >
              ☰
            </button>
          </div>

        </div>
      </header>

      {/* MOBILE OVERLAY */}
      <div className={`salon-mobile ${open ? "open" : ""}`}>
        <button className="close" onClick={() => setOpen(false)}>✕</button>

        <nav>
          <NavLink to="/" end onClick={() => setOpen(false)}>Home</NavLink>
          <NavLink to="/about" onClick={() => setOpen(false)}>About</NavLink>
          <NavLink to="/services" onClick={() => setOpen(false)}>Services</NavLink>
          <NavLink to="/gallery" onClick={() => setOpen(false)}>Gallery</NavLink>
          <NavLink to="/team" onClick={() => setOpen(false)}>Team</NavLink>
          <NavLink to="/reviews" onClick={() => setOpen(false)}>Reviews</NavLink>
          <NavLink to="/faqs" onClick={() => setOpen(false)}>FAQs</NavLink>
          <NavLink to="/contact" onClick={() => setOpen(false)}>Contact</NavLink>
        </nav>
      </div>
    </>
  );
};

export default Header;
